import { languages } from "../../constant/Languages";

export const LanguageSelect = ({
    name,
    label,
    handleSelectLang,
    value,
    error,
    touched
}: any) => {

    return (
        <div key={name}>
            <label className="flex mb-2 mt-3 text-xl font-bold text-darkgray font-roboto  justify-start">
                {label}
            </label>
            <div className="px-2 bg-gray-50 border border-slate-300 rounded-lg  w-full block">
                <select
                    value={value}
                    onChange={(e) => handleSelectLang(e.target.value)}
                    className="text-gray-900 text-sm w-full p-2.5 pl-0 outline-none"
                >
                    <option value="">Select Language</option>
                    {languages?.map((elm: any) => (
                        <option key={elm.code} value={elm.code}>
                            {elm.name}
                        </option>
                    ))}
                </select>
            </div>
            {error && touched && <p className="text-red-600">{error}</p>}
        </div>
    );
};
